import { NotificationProps } from '@mantine/core';
import { notifications, type NotificationsProps } from '@mantine/notifications';
import { IconAlertTriangle, IconCheck, IconX } from '@tabler/icons-react';
import type React from 'react';

export class NotificationsStore {
  showError(message: string, title?: string): void {
    notifications.show({
      color: 'red',
      title,
      icon: <IconX />,
      message,
      autoClose: 4000,
    });
  }

  showSuccess(message: string, title?: string): void {
    notifications.show({
      color: 'teal',
      title,
      icon: <IconCheck />,
      message,
      autoClose: 4000,
    });
  }

  showWarning(message: string, title?: string): void {
    notifications.show({
      color: 'yellow',
      title,
      icon: <IconAlertTriangle />,
      message,
      autoClose: 4000,
    });
  }

  showSuccessAction(params: {
    message: React.ReactNode;
    title?: string;
    onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
    position?: NotificationsProps['position'];
    id?: string;
    autoClose?: number | false;
    onClose?: () => void;
    closeButtonProps?: NotificationProps['closeButtonProps'];
  }): void {
    notifications.show({
      color: 'teal',
      title: params.title,
      icon: <IconCheck />,
      message: params.message,
      autoClose: params.autoClose ?? 5000,
      position: params.position ?? 'top-right',
      id: params.id,
      closeButtonProps: params.closeButtonProps,
      withCloseButton: true,
      onClick: params.onClick,
      onClose: params.onClose,
      style: params.onClick ? { cursor: 'pointer' } : undefined,
    });
  }
}
